import MagazineComponent from '@pixum/magazine';
import ThemeProvider from '@pixum/theme-provider';
import { SkeletonText, SkeletonImage, SkeletonButton, SkeletonTitle } from '@pixum/skeleton';
import { THEME_DEFAULT_PROPS, MAGAZINE_FOCUS } from 'data-layer/constants';

/**
 * DownloadVoucherCampaignSkeleton Component
 *
 * Displays a loading skeleton while the DownloadVoucherCampaign component
 * is being rendered. Matches the Magazine layout structure to prevent CLS.
 *
 * Structure mirrors DownloadVoucherCampaign:
 * - Left (media): Image skeleton for voucher
 * - Right (text): Title + description + form skeleton (input + button)
 *
 * This component is used within a Suspense boundary to provide immediate
 * feedback while searchParams are being resolved and campaign data is loading.
 */
export function DownloadVoucherCampaignSkeleton() {
  const skeletonText = (
    <div role="status" aria-busy="true" style={{ display: 'flex', flexDirection: 'column' }}>
      <SkeletonText lines={3} aria-hidden="true" style={{ marginBottom: '16px' }} />
      <SkeletonTitle aria-hidden="true" style={{ marginTop: '16px', marginBottom: '16px', borderRadius: '4px' }} />
      <SkeletonButton aria-hidden="true" style={{ display: 'flex', alignSelf: 'flex-end' }} />
    </div>
  );

  const skeletonMedia = <SkeletonImage aria-hidden="true" />;

  const magazineProps = {
    className: 'download-voucher-campaign',
    focus: MAGAZINE_FOCUS.TEXT,
    level: 3 as const,
    media: skeletonMedia,
    text: skeletonText,
  };

  return (
    <ThemeProvider theme={THEME_DEFAULT_PROPS}>
      <MagazineComponent {...magazineProps} />
    </ThemeProvider>
  );
}
